import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div>contact@goldenwayve.com</div>
      <div>8 The Green, STE R, Dover, DE 19901, USA</div>
      <div>2024 Golden Wayve Corporation. All rights reserved.</div>
    </footer>
  );
};

export default Footer;